import { render } from "./ProductUnitsSelectSearch.vue?vue&type=template&id=4863676c&scoped=true"
import script from "./ProductUnitsSelectSearch.vue?vue&type=script&lang=js"
export * from "./ProductUnitsSelectSearch.vue?vue&type=script&lang=js"

import "./ProductUnitsSelectSearch.vue?vue&type=style&index=0&id=4863676c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4863676c"]])

export default __exports__